import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Button, Tab, Tabs, TextField, Box, Typography, Grid, IconButton, DialogActions } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import moment from "moment";
import TableComponent from "components/grid";
import CustomPagination from "components/CustomPagination";
import { RxCross2 } from "react-icons/rx";
import { useLazyGetAllIncidentQuery, } from "store/slices/apis/incidentTrackerSlice";
import StatusBadge from "components/badge/StatusBadge";



const HseListPopUp = (props) => {
    const { header, open, handleClose, filter } = props;
    const { projectId } = useParams();
    const [loading, setLoading] = useState(false);
    const [sortOrder, setSortOrder] = React.useState('desc');
    const [sortBy, setSortBy] = React.useState('createdDate');
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);
    const dispatch = useDispatch();
    const [subTabValue, setSubTabValue] = useState(0)


    const [filters, setFilters] = useState({
        ...filter,
        ProjectId: projectId,
        SortBy: sortBy,
        SortOrder: sortOrder,
        PageNumber: pageNumber,
        PageSize: pageSize,
        

    });

    const [trigger, { data: incidentData, isLoading: isloading, isFetching }] = useLazyGetAllIncidentQuery()

    useEffect(() => {
        trigger(filters);
    }, []);




    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';

        const updatedFilters = {
            ...filters,
            SortBy: property,
            SortOrder: isAsc ? 'desc' : 'asc'
        };
        setFilters(updatedFilters);
        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
        trigger(updatedFilters);
    };

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
        const updatedFilters = {
            ...filters,
            PageNumber: newPage,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
        const updatedFilters = {
            ...filters,
            PageSize: newSize,
            PageNumber: 1,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };



    const col = [
        {
            name: "HSE ID",
            field: "customId",
            width: "100px",
            sticky: true,
        },
        {
            name: "Contractor Name",
            field: "contractorName",
            width: "200px",
            sticky: true,
        },
        {
            name: "Status",
            field: "status",
            renderer: (row) => (
                <StatusBadge status={row.status} />
            )
        },
        {
            name: "Type of Incident",
            field: "typeOfIncident",
        },
        {
            name: "Description Of Incident",
            field: "descriptionOfIncident",
            width: "250px",
        },
        {
            name: 'Location',
            field: 'location',
        },
        // {
        //     name: "Time of Incident",
        //     field: "timeOfIncident",
        // },
        {
            name: "Date of Incident",
            field: "dateOfIncident",
            renderer: (row) => (
                row?.dateOfIncident ? moment(row.dateOfIncident).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: 'Incident Severity Rating',
            field: 'incidentSeverityRating',
        },
        {
            name: 'Personnel Involved',
            field: 'personnelInvolved',
        },
        {
            name: 'Injury Details',
            field: 'injuryDetails',
        },
        {
            name: 'LTI Days Lost',
            field: 'ltiDaysLost',
        },
        {
            name: 'Immediate Action Taken',
            field: 'immediateActionTaken',
            width: "300px"
        },
        {
            name: 'Root Cause Identified',
            field: 'rootCauseIdentified',
            width: "300px"
        },
        {
            name: 'Corrective and Preventive Action',
            field: 'correctiveAndPreventiveAction',
            width: "300px"
        },
        {
            name: 'Responsible Person',
            field: 'responsiblePerson',
        },
        {
            name: "Date of Closure",
            field: "dateOfClosure",
            renderer: (row) => (
                row?.dateOfClosure ? moment(row.dateOfClosure).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: 'CAPA Status',
            field: 'capaStatus',
        },
        {
            name: 'Verification Done By',
            field: 'verificationDoneBy',
        },

    ];




    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <Dialog open={open}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >

            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}>
                <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                    {header}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Grid container>
                    <Grid size={{ md: 12 }}>
                        <TableComponent
                            columns={col}
                            data={incidentData?.data || []}
                            createSortHandler={handleRequestSort}
                            loading={isFetching}
                            order={sortOrder}
                            orderBy={sortBy}
                        />
                    </Grid>
                    <Grid size={{ md: 12 }}>
                        <CustomPagination
                            totalCount={incidentData?.totalRecords || 0}
                            pageSize={pageSize}
                            page={pageNumber}
                            onPageChange={handlePageChange}
                            setCurrentPage={setPageNumber}
                            onPageSizeChange={handlePageSizeChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default HseListPopUp;
